"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Grid = void 0;

var React = require("react");

var styled_components_1 = require("styled-components");

var styled_system_1 = require("styled-system");

var lodash_1 = require("lodash");

var Row = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (p) {
  return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n    display: grid;\n    grid-template-columns: repeat(\n      ", ",\n      minmax(1px, 1fr)\n    );\n    grid-gap: ", "px;\n  "], ["\n    ", "\n    display: grid;\n    grid-template-columns: repeat(\n      ", ",\n      minmax(1px, 1fr)\n    );\n    grid-gap: ", "px;\n  "])), styled_system_1.space, p.auto ? 'auto-fit' : p.columns || p.theme.grid.columns, p.gutter || p.theme.grid.gutter);
});
var GridColumn = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), styled_system_1.grid);

function Column(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 1 : _b,
      children = _a.children;
  var columnSizes = typeof size === 'object' ? lodash_1.mapValues(size, function (s) {
    return "span " + s;
  }) : "span " + size;
  return React.createElement(GridColumn, {
    gridColumn: columnSizes
  }, children);
}

exports.Grid = {
  Column: Column,
  Row: Row
};
var templateObject_1, templateObject_2, templateObject_3;